module.exports = {
      id: "ic-envelope-usage",
      viewBox: "0 0 25 24",
      url: __webpack_public_path__ + "sprite-83ccd1.smartcharts.svg#ic-envelope-usage",
      toString: function () {
        return this.url;
      }
    }